import { NEWBUILDING_KPN_CHAT } from 'node/services/fetchExperiments/getExperiments';
import { UNMATCHED_CONTENT_EXPERIMENT, NEWBUILDING_BOOKING_AUTH_EXPERIMENT } from 'shared/selectors/abExperiments';

export const EXPERT_OPINION = 'aud_desktop_bx495_expert_opinion_gpt_newb';

export const EXPERIMENTS: string[] = [
  EXPERT_OPINION,
  NEWBUILDING_KPN_CHAT,
  UNMATCHED_CONTENT_EXPERIMENT,
  NEWBUILDING_BOOKING_AUTH_EXPERIMENT,
];
